export const WhatsNew = () => {
    /* We are using -48px here to subtract the height of the top nav bar. We cannot use h-full in this instance, because the height of
       the content div is not fixed. */
    return (
        <iframe
            className="flex h-screen w-full border-none"
            src="https://www.snackpass.co/updates"
            title="what's New"
        />
    );
};
